"use client"
import { useState } from "react"
import ProblemCard from "./problem-card"

const problems = [
  {
    id: "partner",
    icon: (
      <svg className="w-6 h-6 sm:w-8 sm:h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    ),
    title: "Is your tech partner or team only development-focused?",
    description:
      "They lack the product and UX fundamentals needed to create products that truly resonate with users and solve real problems effectively.",
  },
  {
    id: "alignment",
    icon: (
      <svg className="w-6 h-6 sm:w-8 sm:h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M7.5 8.5h9m-9 6h9M8 4h8a2 2 0 012 2v12a2 2 0 01-2 2H8a2 2 0 01-2-2V6a2 2 0 012-2z"
        />
      </svg>
    ),
    title: "Does your development partner understand your goals?",
    description:
      "A misalignment between technical execution and business objectives leads to products that don't meet market needs or drive growth.",
  },
  {
    id: "ux",
    icon: (
      <svg className="w-6 h-6 sm:w-8 sm:h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
    title: "Is your product technically sound but visually poor?",
    description:
      "Great technology means nothing without an exceptional user experience. Poor UX drives users away, regardless of backend quality.",
  },
]

export default function ProblemIdentification() {
  const [hoveredId, setHoveredId] = useState(null)

  return (
    <section className="bg-[#F8F9FF] min-h-screen py-4 sm:py-8 relative">
      {/* Header Section - Mobile optimized */}
      <div className="mx-4 sm:mx-8 sm:ps-28">
        <div className="py-4 sm:py-8 text-2xl sm:text-3xl font-bold font-poppins tracking-tight text-pink-500 sm:text-2xl">
          <p className="font-lexend mt-4 sm:mt-8 py-2">The Challenge</p>
        </div>
        
        <div className="max-w-5xl marquee-text text-2xl sm:text-3xl font-poppins text-gray-600 inline-block leading-tight sm:leading-normal" style={{ wordSpacing: 0 }}>
          Pinpointing Issues for Effective Solutions
        </div>
        
        <div className="pt-4 sm:pt-8 marquee-text text-base sm:text-lg font-poppins text-gray-800 sm:text-xl pb-4 sm:pb-8">
          <div className="w-full break-words">
            <p className="mb-3 sm:mb-4 leading-relaxed sm:leading-normal" style={{ wordSpacing: -1 }}>
              Building tech and digital products can appear straightforward, 
              yet ensuring they resonate with a specific business domain and meet market demands requires a 
              deeper understanding. Rushing into development without this insight often leads to products that 
              fall short of expectations, failing to address customer needs effectively. This approach not only 
              wastes resources but also risks damaging reputation and losing market opportunities.
            </p>
          </div>
        </div>
      </div>

      {/* Problem Cards Grid - Mobile optimized */}
      <div className="mx-4 sm:mx-8 sm:ps-24 pb-4 sm:pb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {problems.map((problem) => (
            <div
              key={problem.id}
              onMouseEnter={() => setHoveredId(problem.id)}
              onMouseLeave={() => setHoveredId(null)}
              className="transition-all duration-300"
            >
              <ProblemCard
                icon={problem.icon}
                title={problem.title}
                description={problem.description}
                isHovered={hoveredId === problem.id}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}



